!<template>
  <!--发票清单详情弹窗-->
  <div
    class="tc_invoice_box"
    id="saleListBox"
  >
    <div class="tc_main">
      <!--<a href="javascript:;" class="tc_close" id="closeSaleList">关闭</a>-->
      <!--货物清单------------------>
      <div class="hwqd_wrap">
        <h1>销 售 货 物 或 提 供 应 税 劳 务 清 单</h1>
        <table
          style="width: 100%;"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <tbody>
            <tr height="30">
              <td
                class="align_left"
                colspan="3"
              >购买方名称：<span
                  class="content_td_blue"
                  id="saleListPurchaserName"
                >
                  {{invoiceData&&invoiceData.purchaserName}}
                </span></td>
            </tr>
            <tr height="30">
              <td
                class="align_left"
                colspan="3"
              >销售方名称：<span
                  class="content_td_blue"
                  id="saleListSalesName"
                >{{invoiceData&&invoiceData.salesName}}</span></td>
            </tr>
            <tr height="30">
              <td class="align_left"><span id="fpmx_fpdminfo">所属增值税发票代码：</span><span
                  class="content_td_blue"
                  id="saleListInvoiceCode"
                >
                  {{invoiceData&&invoiceData.invoiceCode}}
                </span></td>
              <td class="align_left">号码：<span
                  class="content_td_blue"
                  id="saleListInvoiceNumber"
                >
                  {{invoiceData&&invoiceData.invoiceNumber}}
                </span></td>
              <!--<td class="align_right">共1页 第1页</td>-->
              <td> &nbsp;</td>
            </tr>
          </tbody>
        </table>
        <table
          class="fppy_table"
          style="width: 100%;"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <tbody>
            <tr id="tab_head_mx">
              <td width="60"> 序号</td>
              <td width="240">货物（劳务）名称</td>
              <td width="100">规格型号</td>
              <td width="60"> 单位</td>
              <td width="100">数量</td>
              <td width="100">单价</td>
              <td width="100">金额</td>
              <td width="40"> 税率</td>
              <td width="100">税额</td>
            </tr>

            <tr
              class="saleListRow"
              v-for="(item,index) in invoiceData.items "
              :key="index"
            >
              <td class="borderBottomTopNo content_td_blue rowNo">{{++index}} </td>
              <td class="borderBottomTopNo align_left content_td_blue commodityName">{{item.commodityName}} </td>
              <td class="borderBottomTopNo align_left content_td_blue specificationModel"> {{item.specificationModel}} </td>
              <td class="borderBottomTopNo align_left content_td_blue unit">{{item.unit}}</td>
              <td class="borderBottomTopNo align_right content_td_blue quantity">{{item.quantity}}</td>
              <td class="borderBottomTopNo align_right content_td_blue unitPrice">{{item.unitPrice && parseFloat(item.unitPrice)}}</td>
              <td class="borderBottomTopNo align_right content_td_blue amount">{{item.amount && parseFloat(item.amount)}}</td>
              <td class="borderBottomTopNo align_right content_td_blue taxRate">{{item.taxRate && `${item.taxRate * 100}%`}}</td>
              <td class="borderBottomTopNo align_right content_td_blue tax">{{item.tax && parseFloat(item.tax)}}</td>
            </tr>

            <!--<tr id="saleListStatisticsRow">-->
            <!--<td width="60" class="borderHaveTop"> 小计</td>-->
            <!--<td width="240" class="borderHaveTop align_left"></td>-->
            <!--<td width="100" class="borderHaveTop"></td>-->
            <!--<td width="60" class="borderHaveTop"></td>-->
            <!--<td width="100" class="borderHaveTop align_right"></td>-->
            <!--<td width="100" class="borderHaveTop align_right"></td>-->
            <!--<td width="100" class="bordeirHaveTop align_right content_td_blue" id="saleListTotalAmount"></td>-->
            <!--<td width="40" class="borderHaveTop"></td>-->
            <!--<td width="100" class="borderHaveTop align_right content_td_blue" id="saleListTax"></td>-->
            <!--</tr>-->

            <tr id="saleListStatisticsRow">
              <td
                width="60"
                class="borderBottomTopNo"
              > 总计</td>
              <td
                width="240"
                class="borderBottomTopNo align_left"
              ></td>
              <td
                width="100"
                class="borderBottomTopNo"
              ></td>
              <td
                width="60"
                class="borderBottomTopNo"
              ></td>
              <td
                width="100"
                class="borderBottomTopNo align_right"
              ></td>
              <td
                width="100"
                class="borderBottomTopNo align_right"
              ></td>
              <td
                width="100"
                class="borderBottomTopNo align_right content_td_blue"
                id="saleListTotalAmount"
              >
                ￥ {{invoiceData.totalAmount}}
              </td>
              <td
                width="40"
                class="borderBottomTopNo"
              ></td>
              <td
                width="100"
                class="borderBottomTopNo align_right content_td_blue"
                id="saleListTax"
              >
                ￥ {{invoiceData.totalTax}}
              </td>
            </tr>
            <tr>
              <td class="borderTop">备注</td>
              <td
                class="borderTop align_left content_td_blue"
                colspan="8"
                v-html="invoiceData.remarks"
              >
                <!-- {{invoiceData.remarks}} -->
              </td>
            </tr>
          </tbody>
        </table>
        <br>
        <table
          style="width: 100%;"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <tbody>
            <tr height="30">
              <td class="align_left">销售方（章）：</td>
              <td class="align_right">填开日期：<span
                  class="content_td_blue"
                  id="saleListBillingDate"
                >

                  {{invoiceData.billingDate}}
                </span></td>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>
        <p>注：本清单一式两联；第一联：销方保存；第二联：销售方送交购买方 </p>
        <br />
      </div>
      <!--货物清单------------------>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InvoiceNormalDetail',
  props: ['invoiceData'],
  data() {
    return {
    };
  },
};
</script>
<style  scoped>
</style>
